module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-15.svg?ba8f109960c9d79d35cb6473cadd7296";